import _ from 'lodash';
window._ = _;

import jQuery from 'jquery';
// Do not overwrite a pre-existing global jQuery (loaded via /js/jquery.min.js + extended by CDN plugins
// like jquery-ui sortable). Replacing it would strip those plugins from the instance pages use.
if (!window.jQuery) {
    window.$ = window.jQuery = jQuery;
}

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
